import { defaultDate } from '@/datas/DateFormats'
import { prepareDate } from './functions'
import moment from 'moment'

const unixTimeStampToDate = date => moment.unix(date)
const getDateOfCertainFormat = (date, format, flag = false) => {
  if (!date) {
    return ''
  }
  if (flag) {
    date = prepareDate(date, '.')
  }
  const momentDate = moment(date)

  if (!momentDate.isValid() || date.length < 6) {
    return date
  }

  return momentDate.format(format)
}
const getNow = format => {
  const momentDate = moment()

  return momentDate.format(format)
}
const getBeforeDay = (count, format) => {
  const momentDate = moment().subtract(count, 'days')

  return momentDate.format(format)
}
const getFuturePeriod = (format, countOfPeriod, nameOfPeriod = 'day') => {
  const momentDate = moment().add(countOfPeriod, nameOfPeriod)

  return momentDate.format(format)
}

const isAfterDay = current => nextDay =>
  moment(checkFormat(nextDay)).isSameOrAfter(current)
const isValidDate = date => moment(checkFormat(date)).isValid()
const checkFormat = date =>
  date && date.includes('.') ? prepareDate(date, '.') : date
const getYear = () => moment().year()
const checkYear = (date, year = 1980) =>
  moment(checkFormat(date)).year() >= year

const unixFromString = date => Number(moment(date).format('x'))

const startOfCurrentMonth = () => moment().startOf('month').format(defaultDate)
const endOfCurrentMonth = () => moment().endOf('month').format(defaultDate)

export {
  getDateOfCertainFormat,
  getNow,
  getFuturePeriod,
  unixTimeStampToDate,
  isAfterDay,
  isValidDate,
  getYear,
  checkYear,
  getBeforeDay,
  unixFromString,
  startOfCurrentMonth,
  endOfCurrentMonth,
}
